import { type QuickBooksFieldMapModel } from '../enums/QuickBooksFieldMapModelEnum'
import {
  QuickBooksFieldMappingRow,
  type QuickBooksFieldMappingRowConstructor,
} from '../QuickBooksFieldMappingRow'

export interface QuickBooksFieldMapConstructor {
  model: QuickBooksFieldMapModel
  rows: QuickBooksFieldMappingRowConstructor[]
}

export class QuickBooksFieldMap {
  readonly model: QuickBooksFieldMapModel
  readonly rows: QuickBooksFieldMappingRow[]

  constructor(data: QuickBooksFieldMapConstructor) {
    this.model = data.model
    this.rows = data.rows.map((row) => new QuickBooksFieldMappingRow(row))
  }

  // Order Items / Bill Expense Lines panels show "No fields available."
  // when empty (BHV-011).
  get isEmpty(): boolean {
    return this.rows.length === 0
  }
}
